// import React from 'react';
// import { Link } from 'react-router-dom';
// import { Card, CardContent, CardHeader, CardTitle } from "@/components/card";
// import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/table";
// import { Alert, AlertDescription } from "@/components/alert";
// import { motion } from "framer-motion"; // Add smooth animations
// import Footer from '../../../components/Footer';
// import BtechImg from "../../../assets/images/engineering.jpeg";

// const programDetails = {
//   name: "Bachelor of Technology in Cloud Computing",
//   about: "A Bachelor of Technology (.) in Cloud Computing is an undergraduate program that specializes in the principles, technologies, and practices related to cloud computing. Cloud computing involves the delivery of various computing services over the internet, including storage, servers, databases, networking, software, and more, providing users with on-demand access to scalable resources. Graduates with a . in Cloud Computing are well-equipped to pursue careers as cloud architects, cloud engineers, cloud administrators, and solution architects in various industries. With increasing adoption of cloud technologies across industries, professionals with expertise in cloud computing are in high demand. Obtaining relevant certifications from cloud providers such as Amazon Web Services (AWS), Microsoft Azure, or Google Cloud Platform (GCP) can further enhance career prospects for graduates in this field.",
//   eligibility: "Intermediate / 10+2 or its equivalent examination with PCM (Physics, Chemistry, Maths) from a recognized Board/ University/ MDU Entrance Examination.",
// };

// const feeDetails = [
//   { programme: "Bachelor of Technology (.)", specialization: "Cloud Computing", duration: "4", seats: "60", oneTimeCharges: "Rs.21000/-", allIndiaQuota: "Rs.145000/-", ukDomicile: "Rs.105000/-" },
// ];

// const scholarshipDetails = [
//   { srNo: 1, particulars: "Single Girl Child", category: "-", percentage: "10%", applicable: "All Years" },
//   { srNo: 2, particulars: "Merit Based", category: "75%-80%", percentage: "20%", applicable: "*" },
//   { srNo: 3, particulars: "Merit Based", category: "80%-90%", percentage: "30%", applicable: "*" },
//   { srNo: 4, particulars: "Merit Based", category: "90%-95%", percentage: "50%", applicable: "*" },
//   { srNo: 5, particulars: "Merit Based", category: "95%-100%", percentage: "70%", applicable: "*" },
//   { srNo: 6, particulars: "Hill States (J&K, Ladakh, Assam, Arunachal Pradesh, Manipur, Mizoram, Meghalaya, Sikkim, Tripura, HP, Darjeeling, Kalimpong)", category: "-", percentage: "15%", applicable: "All Years" },
//   { srNo: 7, particulars: "Martyrs/Defence Scholarship", category: "-", percentage: "20%", applicable: "All Years" },
//   { srNo: 8, particulars: "Sport Quota Scholarship", category: "State", percentage: "25%", applicable: "All Years" },
//   { srNo: 9, particulars: "Sport Quota Scholarship", category: "National", percentage: "35%", applicable: "All Years" },
//   { srNo: 10, particulars: "Sport Quota Scholarship", category: "International", percentage: "50%", applicable: "All Years" },
//   { srNo: 11, particulars: "Disabled Student Scholarship", category: "-", percentage: "40%", applicable: "All Years" },
//   { srNo: 12, particulars: "Siblings Scholarship", category: "-", percentage: "25%", applicable: "**" },
//   { srNo: 13, particulars: "Early Bird till 8th June", category: "-", percentage: "40%", applicable: "*" },
// ];

// const BtechCloud = () => {
//   return (
//     <div className="w-full relative font-poppins">
//       <div className="w-10/12 mx-auto mt-[100px] md:mt-[150px] flex flex-col gap-5 md:gap-5">
//         <motion.h2
//           className="mb-4 text-2xl md:text-6xl tracking-tight font-bold text-center text-[#0e4d38]"
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           transition={{ duration: 1 }}
//         >
//           {programDetails.name}
//         </motion.h2>
//         <div className="w-[20%] mx-auto h-[6px] bg-[#23376c] mt-[-10px] md:mt-[-20px]" />

//         <div className="flex flex-col md:flex-row gap-8 mb-10 md:gap-[80px] mt-5 justify-center md:justify-between">
//           <img src={BtechImg} className="md:w-[40%] rounded-lg" />
//           <div className="flex flex-col gap-4">
//             <h4 className="font-bold text-xl md:text-3xl">About the Department</h4>
//             <p className="text-justify md:text-lg">{programDetails.about}</p>
//             <Link to="https://admission.maya.edu.in/">
//               <button className="mt-5 md:mt-0 bg-[#23376c] px-4 py-2 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3]">
//                 Register Now
//               </button>
//             </Link>
//           </div>
//         </div>

//         <div className="flex flex-col gap-10 mt-5 mb-[50px]">
//           <div className="flex flex-col gap-2">
//             <h4 className="text-2xl font-semibold text-[#0e4d38]">Eligibility Criteria</h4>
//             <p>{programDetails.eligibility}</p>
//           </div>
//         </div>

//         {/* Fee Details Table */}
//         <Card>
//           <CardHeader>
//             <CardTitle>Fee Details</CardTitle>
//           </CardHeader>
//           <CardContent>
//           <div className="overflow-x-auto">
//             <Table aria-label="Fee details table">
//               <TableHeader>
//                 <TableRow>
//                   <TableHead>Programme</TableHead>
//                   <TableHead>Branch/ Specialization</TableHead>
//                   <TableHead>Duration (Years)</TableHead>
//                   <TableHead>No. of Seats</TableHead>
//                   <TableHead>One time Charges</TableHead>
//                   <TableHead>Yearly Fee (All India Quota)</TableHead>
//                   <TableHead>Yearly Fee (UK Domicile)</TableHead>
//                 </TableRow>
//               </TableHeader>
//               <TableBody>
//                 {feeDetails.map((fee, index) => (
//                   <TableRow key={index}>
//                     <TableCell>{fee.programme}</TableCell>
//                     <TableCell>{fee.specialization}</TableCell>
//                     <TableCell>{fee.duration}</TableCell>
//                     <TableCell>{fee.seats}</TableCell>
//                     <TableCell>{fee.oneTimeCharges}</TableCell>
//                     <TableCell>{fee.allIndiaQuota}</TableCell>
//                     <TableCell>{fee.ukDomicile}</TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </div>
//           </CardContent>
//         </Card>

//         {/* Scholarship Details Table */}
//         <Card>
//           <CardHeader>
//             <CardTitle>Scholarship Programs</CardTitle>
//           </CardHeader>
//           <CardContent>
//           <div className="overflow-x-auto">
//             <Table aria-label="Scholarship details table">
//               <TableHeader>
//                 <TableRow>
//                   <TableHead>Sr. No</TableHead>
//                   <TableHead>Particulars</TableHead>
//                   <TableHead>Category</TableHead>
//                   <TableHead>Percentage</TableHead>
//                   <TableHead>Applicable</TableHead>
//                 </TableRow>
//               </TableHeader>
//               <TableBody>
//                 {scholarshipDetails.map((scholarship, index) => (
//                   <TableRow key={index}>
//                     <TableCell>{scholarship.srNo}</TableCell>
//                     <TableCell>{scholarship.particulars}</TableCell>
//                     <TableCell>{scholarship.category}</TableCell>
//                     <TableCell>{scholarship.percentage}</TableCell>
//                     <TableCell>{scholarship.applicable}</TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </div>
//           </CardContent>
//         </Card>

//         <div className="flex flex-col gap-10 mt-5 mb-[50px]">
//           <div className="flex flex-col gap-2 items-center justify-center px-10 py-8 rounded-lg bg-[#23376c]">
//             <h4 className="text-2xl font-semibold text-[#0e4d38]">Note</h4>
//             <p className="text-white italic font-semibold">
//               * From 2nd year scholarship will be offered only on 75% attendance in the previous year with no back paper and no misconduct.
//             </p>
//             <p className="text-white font-semibold italic">
//               ** Applicable on those courses whose fees will be less compared to other siblings.
//             </p>
//           </div>
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default BtechCloud;





import React from 'react';
import Footer from '../../../components/Footer';
import BtechImg from "../../../assets/images/engineering.jpeg"; // Update with a relevant cyber security image
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
    Shield,
    GraduationCap,
    Lock,
    Target,
    BookOpen,
    FlaskConical,
    MapPin,
    Users,
    Code,
} from 'lucide-react';

const BtechCloud = () => {
    const fadeIn = {
        initial: { opacity: 0, y: 20 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0.6 }
    };

    return (
        <div className='w-full relative font-poppins'>
            {/* Hero Section */}
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className='relative h-[300px] md:h-[400px] bg-[#0e4d38] mt-[60px] md:mt-[80px] overflow-hidden'
            >
                <div className='absolute inset-0 bg-black/50'></div>
                <div className='relative z-10 h-full flex flex-col justify-center items-center text-white px-4'>
                    <h1 className='text-3xl md:text-6xl font-bold text-center mb-4'>
                        Bachelor of Technology in <br /> Cloud Computing and Engineering
                    </h1>
                </div>
            </motion.div>

            <div className='w-11/12 md:w-10/12 mx-auto mt-8 md:mt-16'>
                {/* About Section */}
                <motion.div
                    {...fadeIn}
                    className='flex flex-col md:flex-row gap-8 mb-10 md:gap-[80px]'
                >
                    <img src={BtechImg} className='md:w-[40%] rounded-xl shadow-lg' alt="Cyber Security" />
                    <div className='flex flex-col gap-4'>
                        <div className='flex items-center gap-3'>
                            <div className='p-2 rounded-lg bg-[#0e4d38] text-white'>
                                <Shield size={24} />
                            </div>
                            <h4 className='font-bold text-2xl md:text-3xl text-[#0e4d38]'>Program Overview</h4>
                        </div>
                        <div className='text-justify md:text-lg space-y-4 text-gray-700'>
                        The Bachelor of Technology (B.Tech.) in Cloud Computing and Engineering is a cutting-edge program designed to equip students with expertise in cloud technologies, distributed systems, and virtualization. As organizations increasingly move their IT infrastructure to cloud environments, there is a growing demand for professionals who can design, implement, and manage cloud-based solutions. This program blends theoretical concepts with hands-on experience in cloud platforms such as Amazon Web Services (AWS), Microsoft Azure, and Google Cloud. Graduates are prepared to excel in roles like cloud solutions architects, cloud engineers, DevOps specialists, and systems administrators.


                        </div>
                        <Link to="https://admission.maya.edu.in/">
                            <motion.button
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                                className='mt-5 md:mt-4 bg-[#23376c] px-6 py-3 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3] flex items-center gap-2'
                            >
                                <GraduationCap size={20} />
                                Apply Now
                            </motion.button>
                        </Link>
                    </div>
                </motion.div>

                {/* Learning Outcomes */}
                <motion.div {...fadeIn} className='mb-12 bg-white p-6 rounded-xl shadow-lg'>
                    <div className='flex items-center gap-3 mb-6'>
                        <div className='p-2 rounded-lg bg-[#0e4d38] text-white'>
                            <Target size={24} />
                        </div>
                        <h4 className='font-bold text-2xl text-[#0e4d38]'>Learning Outcomes</h4>
                    </div>
                    <p className='text-gray-700 leading-relaxed mb-4'>
                    The program focuses on providing students with comprehensive knowledge and skills in cloud computing and related technologies. Key learning outcomes include:
                    </p>
                    <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
                        {[
                            "• Mastery of Cloud Platforms",
                            "• Cloud Infrastructure Management",
                            "• Virtualization and Containerization",
                            "• Data Storage and Management",
                            "• DevOps Practices",
                        ].map((role, index) => (
                            <motion.div
                                key={index}
                                whileHover={{ scale: 1.02 }}
                                className='p-4 bg-gray-50 rounded-lg border border-gray-200'
                            >
                                <p className='text-gray-700 font-medium'>{role}</p>
                            </motion.div>
                        ))}
                    </div>
                </motion.div>

                {/* Laboratories and Facilities */}
                <motion.div {...fadeIn} className='mb-12 bg-white p-6 rounded-xl shadow-lg'>
                    <div className='flex items-center gap-3 mb-6'>
                        <div className='p-2 rounded-lg bg-[#0e4d38] text-white'>
                            <Code size={24} />
                        </div>
                        <h4 className='font-bold text-2xl text-[#0e4d38]'>Laboratories and Facilities</h4>
                    </div>

                    <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
                        {[
                            "• Cloud Computing Lab",
                            "• DevOps Lab",
                            "• Virtualization Lab",
                            "• Big Data Lab",
                        ].map((lab, index) => (
                            <motion.div
                                key={index}
                                whileHover={{ scale: 1.02 }}
                                className='p-4 bg-gray-50 rounded-lg border border-gray-200'
                            >
                                <p className='text-gray-700 font-medium'>{lab}</p>
                            </motion.div>
                        ))}
                    </div>
                </motion.div>

                {/* Admission Requirements */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="bg-white p-6 rounded-xl shadow-lg mb-12"
                >
                    <div className="flex items-center gap-3 mb-6">
                        <div className="p-2 rounded-lg bg-[#0e4d38] text-white">
                            <GraduationCap size={24} />
                        </div>
                        <h4 className="font-bold text-2xl text-[#0e4d38]">Admission Requirements</h4>
                    </div>

                    <div className="space-y-4">
                        <div className="flex items-center gap-3 bg-gray-50 p-4 rounded-lg">
                            <div className="w-2 h-2 bg-[#23376c] rounded-full"></div>
                            <p className="text-gray-700">
                                <span className="font-semibold">Duration of the Program:</span> 4 Years (Semester System)
                            </p>
                        </div>

                        <div className="flex items-center gap-3 bg-gray-50 p-4 rounded-lg">
                            <div className="w-2 h-2 bg-[#23376c] rounded-full"></div>
                            <p className="text-gray-700">
                                <span className="font-semibold">Affiliation:</span> Constituent College of Maya Devi University
                            </p>
                        </div>

                        <div className="flex items-start gap-3 bg-gray-50 p-4 rounded-lg">
                            <div className="w-2 h-2 bg-[#23376c] rounded-full mt-2"></div>
                            <p className="text-gray-700">
                                <span className="font-semibold">Eligibility Criteria:</span> Candidate shall have Passed 12th Examination with Physics, Chemistry, and Mathematics subjects and should have obtained at least 45% in case of general category and 40% in case of reserved category from a recognized board.
                            </p>
                        </div>

                        <div className="flex items-center gap-3 bg-gray-50 p-4 rounded-lg">
                            <div className="w-2 h-2 bg-[#23376c] rounded-full"></div>
                            <p className="text-gray-700">
                                <span className="font-semibold">Mode of Admission:</span> As per university procedure
                            </p>
                        </div>
                    </div>
                </motion.div>
            </div>
            <Footer />
        </div>
    );
};

export default BtechCloud;
